import { useMemo, useState } from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { SP_BREAKPOINT } from "../../../constants/app";
import { PRIMARY_LIGHT_GREEN } from "../../../constants/color";
import { Button } from "../../atoms/Button";
import { PlusIcon } from "../../atoms/icons/PlusIcon";

type Props = {
  onFileUpload: (file: File) => void;
  accept?: string;
};

export const FileUpload: React.FC<Props> = ({ onFileUpload, accept }) => {
  const uuid = useMemo(() => {
    return uuidv4();
  }, []);

  const [onDropOver, setOnDropOver] = useState<boolean>(false);

  return (
    <StyledBackground>
      <StyledFileUploadContainer
        onDrop={(e) => {
          e.preventDefault();
          setOnDropOver(false);
          const files = e.dataTransfer.files;
          if (files && files.length > 0) {
            onFileUpload(files[0]);
          }
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setOnDropOver(true);
        }}
        onDragEnd={(e) => {
          e.preventDefault();
          setOnDropOver(false);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setOnDropOver(false);
        }}
        $onDropOver={onDropOver}
      >
        <StyledFileUploadHeader>
          <StyledTitle>Excelファイルをここにドラッグ＆ドロップ</StyledTitle>

          <StyledSubTitle>もしくは</StyledSubTitle>
        </StyledFileUploadHeader>

        <input
          id={`file-upload-${uuid}`}
          type="file"
          hidden
          accept={accept ?? ""}
          onInput={(e) => {
            const files = (e.target as HTMLInputElement).files;
            if (files && files.length > 0) {
              onFileUpload(files[0]);
            }

            e.currentTarget.value = "";
          }}
        />

        <StyledFileUploadFooter>
          <Button
            text="ファイル選択"
            variant="border"
            icon={PlusIcon}
            fullWidth
            onClick={() => {
              const fileUpload = document.getElementById(
                `file-upload-${uuid}`,
              ) as HTMLInputElement;
              fileUpload.click();
            }}
          />

          <StyledFileText>
            （ファイルはExcelのみ選択可、サイズの上限は10MBまで）
          </StyledFileText>
        </StyledFileUploadFooter>
      </StyledFileUploadContainer>
    </StyledBackground>
  );
};

const StyledBackground = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  background-color: ${PRIMARY_LIGHT_GREEN};
`;

const StyledFileUploadContainer = styled.div<{ $onDropOver: boolean }>`
  @media (max-width: ${SP_BREAKPOINT}) {
    padding: 24px 32px;
  }

  display: flex;
  padding: 40px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border-radius: 12px;
  border: 2px dashed #cccccc;
  background-color: ${({ $onDropOver }) =>
    $onDropOver ? `#eeeeee;` : "#ffffff;"};
`;

const StyledFileUploadHeader = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    display: none;
  }

  width: 390px;
  height: 64px;
  flex-shrink: 0;
`;

const StyledTitle = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
`;

const StyledSubTitle = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
`;

const StyledFileUploadFooter = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
  }

  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;

  button {
    @media (max-width: ${SP_BREAKPOINT}) {
      max-width: 100%;
    }

    max-width: 300px;
  }
`;

const StyledFileText = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;
